
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications/copilots",
      function () {
        return require("private-next-pages/applications/copilots.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applications/copilots"])
      });
    }
  